import React from 'react';
import Select from 'react-select';
import FaIcon from '../../../../FaIcon';
import dsSelectStyles from '../reactSelectDsStyles';

class MultiChoice extends React.Component {
  static defaultProps = {
    label: '',
    tooltipText: null,
    onChange: () => alert('MultiChoice Onchange'),
    options: [],
    selected: [],
    selectAll: true,
  };

  constructor(props) {
    super(props);

    this.multiSelectOnChange = this.multiSelectOnChange.bind(this);
  }

  multiSelectOnChange(selected) {
    let selectedValues = null;
    if (selected) {
      if (selected.find((option) => option.value === 'all')) {
        selectedValues = this.props.options.map((i) => i.value);
      } else {
        selectedValues = selected.map((i) => i.value);
      }
    } else {
      selectedValues = [];
    }
    this.props.onChange(selectedValues);
  }

  renderList() {
    const options = this.props.selectAll
      ? [{ label: 'Select All', value: 'all' }, ...this.props.options]
      : this.props.options;
    let selectedValues = this.getSelectedValues();
    return (
      <Select
        className='multichoicedropdownparent'
        options={options}
        isMulti={true}
        onChange={this.multiSelectOnChange}
        value={selectedValues}
        // Portal the menu so it isn't clipped by (and doesn't grow) a scroll container,
        // e.g. the edit wizard's .EditPanelInput body.
        menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
        // components={{ Menu }}
        styles={dsSelectStyles}
      />
    );
  }

  getSelectedValues() {
    let result = this.props.options.filter((o) => this.props.selected && this.props.selected.includes(o.value));
    return result;
  }

  render() {
    return (
      <div
        className='text-center arial w-100'
        key='mkkey'
      >
        {this.props.label && (
          <label
            key='lab'
            className='m-0 p-0 defaultfontsize '
            htmlFor={'htmlidfor' + this.props.fieldName}
          >
            {this.props.label}
            {this.props.tooltipText ? (
              <>
                &nbsp;
                <FaIcon
                  iconName='fa-solid fa-circle-info'
                  tooltipText={this.props.tooltipText}
                />
              </>
            ) : null}
          </label>
        )}
        {this.renderList()}
      </div>
    );
  }
}

export default MultiChoice;
